import { render, staticRenderFns } from "./AnswerSemiology.vue?vue&type=template&id=714f91b7&"
import script from "./AnswerSemiology.vue?vue&type=script&lang=js&"
export * from "./AnswerSemiology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports